import type { DeepString } from "@/lib/i18n";

/**
 * ProductCard - shared UI dla kafelka produktu (uzywany w CShopCategory list view,
 * przyszlych oknach: bestsellery, promocje, produkty polecane).
 * Zawiera stringi charakterystyczne dla kafelka (badge, status, cena, przycisk
 * "do koszyka"). Wieksze konteksty (nazwa kategorii, opis, warianty) - nie tu.
 */
export const pl = {
  addToCart: "Dodaj do koszyka",
  addingToCart: "Dodaję...",
  addedToCart: (productName: string): string =>
    `Dodano do koszyka: ${productName}.`,
  addToCartFailed: "Nie udało się dodać produktu do koszyka.",
  badges: {
    bestseller: "Bestseller",
    recomended: "Polecany",
    new: "Nowy",
  },
  status: {
    temporary_unavailable: "Tymczasowo niedostępny.",
    archive: "Archiwalny.",
    in_set: "Dostępny tylko w zestawie.",
  },
  /** `formatPrice(129.9, "zł")` -> "129,90 zł". Puste currency -> tylko liczba. */
  formatPrice: (value: number, currency: string): string => {
    const rounded = (Math.round(value * 100) / 100).toFixed(2).replace(".", ",");
    return currency ? `${rounded} ${currency}` : rounded;
  },
  /** `lowestPrice("129,90 zł")` -> "Najniższa cena z ostatnich 30 dni: 129,90 zł". */
  lowestPrice: (formatted: string): string =>
    `Najniższa cena z ostatnich 30 dni: ${formatted}`,
} as const;

export type ProductCardTranslations = DeepString<typeof pl>;
